import { render, staticRenderFns } from "./doctype-list.vue?vue&type=template&id=3be0c812&scoped=true&"
import script from "./doctype-list.vue?vue&type=script&lang=js&"
export * from "./doctype-list.vue?vue&type=script&lang=js&"
import style0 from "./doctype-list.vue?vue&type=style&index=0&id=3be0c812&lang=less&scoped=true&"
import style1 from "./doctype-list.vue?vue&type=style&index=1&id=3be0c812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0c812",
  null
  
)

export default component.exports